'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchBoardDescendantCountAndDecrease = exports.fetchBoardDescendantCountAndIncrease = exports.decreaseElementCount = exports.increaseElementCount = undefined;

var _http = require('../../utils/services/http');

var _http2 = _interopRequireDefault(_http);

var _logger = require('../../utils/logger');

var _logger2 = _interopRequireDefault(_logger);

var _elementCountConstants = require('./elementCountConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var increaseElementCount = exports.increaseElementCount = function increaseElementCount(counts, transactionId) {
    return {
        type: _elementCountConstants.ELEMENT_COUNT_INCREAESE,
        counts: counts,
        transactionId: transactionId
    };
};

var decreaseElementCount = exports.decreaseElementCount = function decreaseElementCount(counts, transactionId) {
    return {
        type: _elementCountConstants.ELEMENT_COUNT_DECREASE,
        counts: counts,
        transactionId: transactionId
    };
};

var fetchBoardDescendantCountAndModify = function fetchBoardDescendantCountAndModify(modificationFn) {
    return function (elementId, transactionId) {
        return function (dispatch, getState) {
            return (0, _http2.default)({
                url: 'boards/' + elementId + '/count',
                params: {
                    creatorId: getState().getIn(['app', 'currentUser', '_id'])
                }
            }).then(function (_ref) {
                var data = _ref.data;
                return dispatch(modificationFn(data.elementCount, transactionId));
            }).catch(function (error) {
                _logger2.default.warn(error);
            });
        };
    };
};

var fetchBoardDescendantCountAndIncrease = exports.fetchBoardDescendantCountAndIncrease = fetchBoardDescendantCountAndModify(increaseElementCount);
var fetchBoardDescendantCountAndDecrease = exports.fetchBoardDescendantCountAndDecrease = fetchBoardDescendantCountAndModify(decreaseElementCount);


//////////////////
// WEBPACK FOOTER
// ./src/client/user/elementCount/elementCountActions.js
// module id = 464
// module chunks = 0